































































































































































import Vue from "vue";
import store from "@/vuex/store";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { ICustomer, ICustTypeDto } from "../../../interfaces";
import { makeCustomer } from "../../../utils";
import {
  REQUIRED_RULE,
  FIRST_NAME_VALIDATORS,
  LAST_NAME_VALIDATORS,
  EMAIL_VALIDATORS,
  PHONE_VALIDATORS,
  ADDRESS1_RULES,
  COMPANY_NAME_VALIDATORS,
  CUSTOMER_NAME_VALIDATORS
} from "@/validators";
import CustomerTypeEditor from "./../office/customer-type.vue";

@Component({
  components: { CustomerTypeEditor }
})
export default class SuperCustomerEditor extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  mounted() {}
  // created(){}

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value: any;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  public cust: ICustomer = makeCustomer({});

  public req = REQUIRED_RULE;
  public addressRules = ADDRESS1_RULES;
  public customerNameRules = CUSTOMER_NAME_VALIDATORS;
  public companyNameRules = COMPANY_NAME_VALIDATORS;
  public firstNameRules = FIRST_NAME_VALIDATORS;
  public lastNameRules = LAST_NAME_VALIDATORS;
  public emailRules = EMAIL_VALIDATORS;
  public phoneRules = PHONE_VALIDATORS;

  /* VUE WATCH */
  @Watch("value", { immediate: true })
  onValueChanged(newVal: ICustomer, oldVal: ICustomer) {
    this.cust = newVal;
  }

  /* VUE COMPUTED METHODS */
  get req_rules(): any {

		/// RETAIL CUSTOMERS DON'T REQUIRE ADDRESS INFORMATION TO BE ENTERED. 
		/// 
		if (this.cust.CustType.IsRetail)return [];
		return this.req;
  }

  /* VUE METHODS */
  public HasFlag(id: number): boolean {
    var iof = this.cust.CustType.CustTypeFlags.indexOf(id);
    var hasIt: boolean = iof > -1;
    return hasIt;
  }
}
